import { useTheme } from 'foundations-theming/utils';
import once from 'transmute/once';
export const baseWrapperStyle = {
  // Ensures we fill the whole `th` and line our contents up properly
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
};
export const draggingWrapperStyle = once(background => Object.assign({}, baseWrapperStyle, {
  opacity: 0.5,
  background
}));
export const useDraggingWrapperStyle = isDragging => {
  const theme = useTheme();
  return isDragging ? draggingWrapperStyle(theme.color['fill-surface-raised']) : baseWrapperStyle;
};